import { ko, ja, enUS } from 'date-fns/locale';
import { Locale } from 'date-fns';
import { ProviderProps } from '../provider';

type DatePickerLocale = {
  key: Locale['code'];
  value: Locale;
};

export const datePickerLocales: DatePickerLocale[] = [
  { key: ko.code, value: ko },
  { key: ja.code, value: ja },
  { key: enUS.code, value: enUS },
];

// @ts-expect-error : TS2339
export function getDatePickerLocale(currentLang?: ProviderProps['locale']['lang']): Locale {
  const locale = datePickerLocales.find((locale) => locale?.key === currentLang);
  return locale ? locale?.value : ko;
}
